import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/da19e35rlbpoffc5h2ug";

type Status = "idle" | "loading" | "success" | "error";

export default function Subscribe() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐检测：非空则不真正提交，但给出与正常一致的反馈
    const honeypot = fd.get("website_alt");
    if (honeypot && String(honeypot).trim() !== "") {
      setStatus("success");
      setMessage("订阅成功！我们会将最新更新第一时间发送到你的邮箱。");
      form.reset();
      return;
    }

    fd.delete("website_alt");

    setStatus("loading");
    setMessage("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = /spam/i.test(responseText) || /spam/i.test(serverMsg || "");
      const ok = res.ok && parsed?.code === "OK";

      if (ok && !isSpam) {
        setStatus("success");
        setMessage("订阅成功！我们会将最新更新第一时间发送到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg && String(serverMsg).trim() ? String(serverMsg) : "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  };

  return (
    <section id="subscribe" className="relative overflow-hidden py-16 md:py-24">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20fantasy%20illustration%20of%20glowing%20golden%20magic%20letters%20and%20sealed%20scrolls%20floating%20in%20warm%20amber%20light%2C%20deep%20ink%20background%2C%20ethereal%20particles%2C%20mystical%20warm%20atmosphere%2C%20manga%20style%2C%20high%20detail&width=1600&height=700&seq=qm-sub-01&orientation=landscape"
          alt="订阅奇妙漫画追漫更新背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/95 to-background-50"></div>
      </div>

      <div className="relative mx-auto max-w-2xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 px-4 py-1.5 text-sm font-medium text-primary-500">
          <i className="ri-mail-send-line"></i>
          追漫订阅
        </span>
        <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          不错过任何高能剧情
        </h2>
        <p className="mt-3 text-base text-foreground-700">
          留下你的邮箱，第一时间收到关注作品的更新提醒。
        </p>

        <form
          id="subscribe-form"
          data-readdy-form
          className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row"
          onSubmit={handleSubmit}
        >
          <input
            type="email"
            name="email"
            required
            placeholder="请输入常用邮箱"
            className="h-12 flex-1 rounded-full border border-background-300 bg-background-100/80 px-5 text-sm text-foreground-950 placeholder:text-foreground-600 focus:border-primary-500 focus:outline-none"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60 whitespace-nowrap"
          >
            {status === "loading" ? (
              <>
                <i className="ri-loader-4-line animate-spin"></i>
                提交中
              </>
            ) : (
              <>
                <i className="ri-mail-line"></i>
                订阅追更
              </>
            )}
          </button>
        </form>

        {status === "success" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary-500/15 px-4 py-2 text-sm text-primary-500">
            <i className="ri-checkbox-circle-line"></i>
            {message}
          </p>
        )}
        {status === "error" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-accent-500/15 px-4 py-2 text-sm text-accent-600">
            <i className="ri-error-warning-line"></i>
            {message}
          </p>
        )}
        <p className="mt-4 text-xs text-foreground-600">
          免费订阅，随时可退订。我们尊重你的隐私，绝不发送垃圾邮件。
        </p>
      </div>
    </section>
  );
}